import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { SiteSimpleImage } from "../../../../commonComponents/inline/siteSimpleImage";
import { LinkTargetProperties } from "../../../../../global/components/linkSettings/interfaces";
import { formatDuration, ProcessedAudioArticlesRecommendationsItem, resolveImageSrc } from "../audioArticlesRecommendationsUtils";

export type AudioArticlesRecommendationsAction = "youtube" | "apple" | "spotify" | "share";

interface AudioArticlesRecommendationsItemCardProps {
    item: ProcessedAudioArticlesRecommendationsItem;
    imagesDomain?: string;
    categoryIconFirst?: boolean;
    actions?: AudioArticlesRecommendationsAction[];
    onCardClick?: (itemForPlayer: ProcessedAudioArticlesRecommendationsItem) => void;
    href?: string;
    children?: React.ReactNode;
}

const ACTION_CLASS: { [key in AudioArticlesRecommendationsAction]: string } = {
    youtube: "actionButtonYoutube",
    apple: "actionButtonApplePodcasts",
    spotify: "actionButtonSpotify",
    share: "actionButtonShare",
};

const ACTION_LABEL: { [key in AudioArticlesRecommendationsAction]: string } = {
    youtube: "youtube",
    apple: "apple podcasts",
    spotify: "spotify",
    share: "share",
};

export class AudioArticlesRecommendationsItemCard extends React.Component<AudioArticlesRecommendationsItemCardProps, {}> {
    render() {
        const {
            item,
            imagesDomain,
            categoryIconFirst,
            actions,
            onCardClick,
            href,
            children,
        } = this.props;

        const {
            imageUrl,
            categoryName,
            dateUpdatedOnSite,
            title,
            link,
            targetLink,
            categoryIconSrc,
            categoryIcon,
        } = item;

        const hasDate = !!(dateUpdatedOnSite && typeof dateUpdatedOnSite === "string" && dateUpdatedOnSite.trim());
        const imageSrc = resolveImageSrc(imageUrl || "", imagesDomain || "");
        const resolvedCategoryIconSrc = resolveImageSrc(categoryIcon || categoryIconSrc || "", imagesDomain || "");
        const mediaDuration = item.hasVideo && item.videoData && item.videoData.duration
            ? item.videoData.duration
            : (item.duration || 0);
        const itemForPlayer: ProcessedAudioArticlesRecommendationsItem = {
            ...item,
            imageUrl: imageSrc || imageUrl || "",
            categoryIconSrc: resolvedCategoryIconSrc,
        };

        const categoryIconEl = (
            <SiteSimpleImage
                className="itemPodcastIcon"
                src={resolvedCategoryIconSrc}
                alt={categoryName || ""}
                onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
            />
        );
        const categoryNameEl = <span className="itemCategory">{categoryName}</span>;

        const content = (
            <>
                {children}
                <div className="itemImage">
                    {imageSrc && <img src={imageSrc} alt="" />}
                    <span className="playIcon" aria-hidden="true" />
                </div>

                <div className="itemContent">
                    <div className="itemMetaRow">
                        <div className="itemCategoryWrap">
                            {categoryIconFirst ? categoryIconEl : null}
                            {categoryNameEl}
                            {!categoryIconFirst ? categoryIconEl : null}
                        </div>
                        <div className="itemMetaDateWrap">
                            {hasDate && <DateDisplay className="itemDate" date={dateUpdatedOnSite} isHiddenHourInYesterday={true} />}
                        </div>
                    </div>

                    <h4 className="itemTitle" dangerouslySetInnerHTML={{ __html: title }} />

                    <div className="itemFooter">
                        <span className="itemDuration">{formatDuration(mediaDuration)}</span>
                        {actions && actions.length > 0 && (
                            <div className="itemActions" onClick={(e) => e.stopPropagation()}>
                                {_.map(actions, (action: AudioArticlesRecommendationsAction) => (
                                    <HyperLinkBuilder key={action} href={link} linkTarget={targetLink as LinkTargetProperties}>
                                        <button className={`actionButton ${ACTION_CLASS[action]}`} aria-label={ACTION_LABEL[action]} />
                                    </HyperLinkBuilder>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </>
        );

        if (href) {
            return (
                <a className="itemCard" href={href}>
                    {content}
                </a>
            );
        }

        return (
            <div
                className="itemCard"
                onClick={onCardClick ? () => onCardClick(itemForPlayer) : undefined}
            >
                {content}
            </div>
        );
    }
}
